import { render } from "./SubmissionComponent.vue?vue&type=template&id=872ffaf6&scoped=true"
import script from "./SubmissionComponent.vue?vue&type=script&lang=js"
export * from "./SubmissionComponent.vue?vue&type=script&lang=js"

import "./SubmissionComponent.vue?vue&type=style&index=0&id=872ffaf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872ffaf6"]])

export default __exports__